import * as Yup from "yup";

export const OTHER_OPTION_KEY = "OTHER";

export const REPORT_OPTIONS = [
  {
    label: "dubious",
    code: "SEEMS_DUBIOUS",
  },
  {
    label: "wrongLocation",
    code: "NOT_IN_SELECTED_LOCATION",
  },
  {
    label: "wrongCategory",
    code: "NOT_FIT_SELECTED_CATEGORY",
  },
  {
    label: "sold",
    code: "ALREADY_SOLD_OR_RESERVED",
  },
  {
    label: "advertisingSpace",
    code: "USED_AS_ADVERTISING_SPACE",
  },
  {
    label: "request",
    code: "REQUEST",
  },
  {
    label: "other",
    code: OTHER_OPTION_KEY,
  },
];

export const FORM_INITIAL_VALUES: ReportObjectForm = {
  codes: [],
  email: "",
  message: "",
  emailController: false,
};

export const validationSchema = (t: (value: string) => string) =>
  Yup.object({
    codes: Yup.array()
      .of(Yup.string())
      .min(1, t("housingCardDetails.reportObject.errors.required"))
      .required(t("housingCardDetails.reportObject.errors.required")),
    email: Yup.string()
      .email(t("housingCardDetails.reportObject.errors.email"))
      .when("emailController", {
        is: false,
        then: (schema) => schema.required(t("housingCardDetails.reportObject.errors.required")),
      }),

    message: Yup.string().when("codes", {
      is: (value: string[] | undefined) => Array.isArray(value) && value.includes(OTHER_OPTION_KEY),
      then: (schema) => schema.required(t("housingCardDetails.reportObject.errors.required")),
    }),
    emailController: Yup.boolean().required(t("housingCardDetails.reportObject.errors.required")),
  });

export type ReportObjectForm = Yup.InferType<ReturnType<typeof validationSchema>>;
